import React, { useRef } from "react";
import { BiArrowBack, BiPowerOff, BiUser } from "react-icons/bi";
import { NavLink } from "react-router-dom";
import ShortProfile from "./ShortProfile";
import { Menu } from "primereact/menu";
import {
	RiArrowDownSFill,
	RiExchangeDollarFill,
	RiProductHuntLine,
} from "react-icons/ri";
import useAuthStore from "store/authStore";
import useOverlayStore from "store/overlayStore";
import { BsBookmarks, BsDashCircleDotted, BsTerminal } from "react-icons/bs";
import { FiUsers } from "react-icons/fi";
import useLogout from "api/UserResource/useLogout";
import Subscriptions from "admin/Subscriptions";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { IoKeypadOutline } from "react-icons/io5";
import { MdOutlineSubject } from "react-icons/md";
import useCurrencyStore from "store/currencyStore";
import Configs from "admin/Configs";
import { HiOutlineTicket } from "react-icons/hi";
import { useLocation } from "react-router-dom";
import { activeCurrencies } from "utils";
import { FaRegBuilding } from "react-icons/fa";

const Admin2 = ({ children }) => {
	const menu = useRef(null);

	const location = useLocation();

	const showCurrencySelector = ["/books/admin/all"].includes(location.pathname);

	const { hasRoles, userProfile } = useAuthStore();

	const { currency, setCurrency } = useCurrencyStore();

	const {
		setShowCreateBook,
		setShowCreateUser,
		setShowCreateCategory,
		setShowCreateCollection,
		setShowCreateSubscription,
		setShowCreateRate,
		setShowUploadBooks,
		setShowCreateSubjectGroups,
		setShowUploadUsers,
	} = useOverlayStore();

	const items = [];

	if (hasRoles(["Senior Publisher"])) {
		items.push(
			{
				label: "Book",
				command: () => setShowCreateBook(true),
			},
			{ label: "Bulk Upload Books", command: () => setShowUploadBooks(true) },
			{
				label: "User",
				command: () => setShowCreateUser(true),
			}
		);
	} else if (hasRoles(["Publisher"])) {
		items.push(
			{
				label: "Book",
				command: () => setShowCreateBook(true),
			},
			{ label: "Bulk Upload Books", command: () => setShowUploadBooks(true) }
		);
	} else if (hasRoles(["Institution", "Educator"])) {
		items.push(
			{
				label: "User",
				command: () => setShowCreateUser(true),
			},
			{
				label: "Upload Students",
				command: () => setShowUploadUsers(true),
			},
			{
				label: "Subject Group",
				command: () => setShowCreateSubjectGroups(true),
			}
		);
	} else if (hasRoles(["Super Administrator", "Administrator"])) {
		items.push(
			{
				label: "Book",
				command: () => setShowCreateBook(true),
			},
			{
				label: "User",
				command: () => setShowCreateUser(true),
			},
			{
				label: "Book Category",
				command: () => setShowCreateCategory(true),
			},
			{
				label: "Book Collection",
				command: () => setShowCreateCollection(true),
			},
			{
				label: "Subscription plan",
				command: () => setShowCreateSubscription(true),
			},
			{ label: "Bulk Upload Books", command: () => setShowUploadBooks(true) }
			// { label: "Student or Teacher", command: () => setShowUploadBooks(true) }
		);
	}

	let adminDashboard = "/admin-dashboard";

	if (hasRoles(["Senior Publisher", "Publisher"])) {
		adminDashboard = "/publisher-dashboard";
	} else if (hasRoles(["Institution", "Educator"])) {
		adminDashboard = "/institution-dashboard";
	}

	const { mutateAsync, isLoading } = useLogout();
	const handleLogout = async () => {
		await mutateAsync();
	};

	return (
		<div className="flex w-full min-h-screen relative text-sm font-thin font-sans text-akgreenest bg-white">
			<div
				className="w-64 sticky top-0 h-screen px-3 py-4 flex flex-col"
				style={{ background: "rgba(127, 180, 45, 0.2)" }}
			>
				<ShortProfile />

				<nav className="mt-4 px-4 space-y-3">
					<NavLink
						to={adminDashboard}
						className="text-akgreenest flex items-center gap-2 text-base"
						activeClassName="text-akgreener font-cera-black"
					>
						<BsDashCircleDotted size={25} />
						Dashboard
					</NavLink>

					{hasRoles([
						"Super Administrator",
						"Administrator",
						"Senior Publisher",
						"Publisher",
					]) && (
						<NavLink
							to="/books/admin/all"
							className="text-akgreenest flex items-center gap-2 text-base"
							activeClassName="text-akgreener font-cera-black"
						>
							<BsBookmarks size={25} />
							Books
						</NavLink>
					)}

					{hasRoles(["Institution", "Educator"]) && (
						<NavLink
							to="/books/institution"
							className="text-akgreenest flex items-center gap-2 text-base"
							activeClassName="text-akgreener font-cera-black"
						>
							<BsBookmarks size={25} />
							Books
						</NavLink>
					)}

					{hasRoles(["Super Administrator", "Administrator"]) && (
						<NavLink
							to="/books/admin/genres-and-categories"
							className="text-akgreenest flex items-center gap-2 text-base"
							activeClassName="text-akgreener font-cera-black"
						>
							<BsBookmarks size={25} />
							Book categories
						</NavLink>
					)}

					{hasRoles([
						"Super Administrator",
						"Administrator",
						"Senior Publisher",
						"Institution",
						"Educator",
					]) && (
						<NavLink
							to="/users/admin/all"
							className="text-akgreenest flex items-center gap-2 text-base"
							activeClassName="text-akgreener font-cera-black"
						>
							<FiUsers size={25} />
							Users
						</NavLink>
					)}

					{hasRoles(["Senior Publisher", "Publisher"]) && (
						<NavLink
							to="/books/publisher/purchased"
							className="text-akgreenest flex items-center gap-2 text-base"
							activeClassName="text-akgreener font-cera-black"
						>
							<BsBookmarks size={25} />
							Sold books
						</NavLink>
					)}

					{hasRoles([
						"Super Administrator",
						"Administrator",
						"Institution",
						"Educator",
					]) && (
						<NavLink
							to="/subject-groups"
							className="text-akgreenest flex items-center gap-2 text-base"
							activeClassName="text-akgreener font-cera-black"
						>
							<MdOutlineSubject size={25} />
							Subject Areas
						</NavLink>
					)}

					{hasRoles(["Super Administrator", "Administrator"]) && (
						<>
							<NavLink
								to="/roles-and-permissions"
								className="text-akgreenest flex items-center gap-2 text-base"
								activeClassName="text-akgreener font-cera-black"
							>
								<IoKeypadOutline size={25} />
								Roles/Permissions
							</NavLink>

							<NavLink
								to="/vouchers"
								className="text-akgreenest flex items-center gap-2 text-base"
								activeClassName="text-akgreener font-cera-black"
							>
								<HiOutlineTicket size={25} />
								Vouchers
							</NavLink>

							<NavLink
								to="/pay-publisher"
								className="text-akgreenest flex items-center gap-2 text-base"
								activeClassName="text-akgreener font-cera-black"
							>
								<HiOutlineTicket size={25} />
								Publisher Payments
							</NavLink>

							<NavLink
								to="/publishers"
								className="text-akgreenest flex items-center gap-2 text-base"
								activeClassName="text-akgreener font-cera-black"
							>
								<FaRegBuilding size={25} />
								Publishers
							</NavLink>

							<NavLink
								to="/orders"
								className="text-akgreenest flex items-center gap-2 text-base"
								activeClassName="text-akgreener font-cera-black"
							>
								<RiProductHuntLine size={25} />
								Orders
							</NavLink>
						</>
					)}

					{hasRoles(["Super Administrator"]) &&
						userProfile.email === "leonard.ganyire@akello.co" && (
							<NavLink
								to="/command-center"
								className="text-akgreenest flex items-center gap-2 text-base"
								activeClassName="text-akgreener font-cera-black"
							>
								<BsTerminal size={25} />
								Command center
							</NavLink>
						)}
				</nav>

				<footer className="flex-1 flex flex-col justify-end px-4 gap-4">
					<NavLink to="/my-account" className="flex gap-1 items-center">
						<BiUser size={20} />
						My Profile
					</NavLink>

					<button
						type="button"
						className="px-2 py-2 rounded-full bg-akgreener shadow-md flex gap-1 items-center text-white max-w-max"
						onClick={() => handleLogout()}
					>
						{isLoading ? (
							<AiOutlineLoading3Quarters
								size={20}
								className="animate-spin text-white"
							/>
						) : (
							<BiPowerOff size={20} className={`text-white`} />
						)}
						Logout
					</button>
				</footer>
			</div>

			<div className="pb-4 flex-grow flex flex-col min-h-screen relative">
				<div
					className="flex justify-between sticky top-0 py-4 bg-white px-12 bg-gradient-to-b from-gray-300 to-white"
					style={{ zIndex: 999 }}
				>
					<NavLink
						to={"/books"}
						className="hover:bg-akgreener hover:text-white flex gap-1 items-center px-2 py-1 rounded-full border border-akgreener text-akgreener "
					>
						<BiArrowBack size={15} /> Home
					</NavLink>

					{showCurrencySelector && (
						<div className="flex items-center gap-2">
							<p>Show prices in</p>
							<select
								name="price_currency"
								onChange={(e) => setCurrency(e.target.value)}
								className="px-2 py-1 border border-green-200 rounded-lg"
							>
								<option
									value={activeCurrencies.USD.code}
									selected={currency === activeCurrencies.USD.code}
								>
									{activeCurrencies.USD.label}
								</option>
								<option
									value={activeCurrencies.ZWL.code}
									selected={currency === activeCurrencies.ZWL.code}
								>
									{activeCurrencies.ZWL.label}
								</option>
							</select>
						</div>
					)}

					<div className="flex items-center gap-4">
						{hasRoles(["Super Administrator", "Administrator"]) && <Configs />}

						{hasRoles(["Super Administrator", "Administrator"]) && (
							<Subscriptions />
						)}

						{hasRoles([
							"Super Administrator",
							"Administrator",
							"Senior Publisher",
							"Publisher",
						]) && (
							<button
								type="button"
								onClick={() => setShowCreateRate(true)}
								className="flex items-center gap-1 px-2 py-1 bg-gradient-to-b from-akgreen to-gray-300 rounded-lg"
							>
								<RiExchangeDollarFill size={20} />
								Rates
							</button>
						)}

						<Menu
							model={items}
							className="max-w-max font-sans text-sm"
							popup
							ref={menu}
							id="popup_menu"
							style={{ minWidth: 120 }}
						/>
						<button
							type="button"
							onClick={(event) => menu.current.toggle(event)}
							aria-controls="popup_menu"
							aria-haspopup
							style={{ width: 130 }}
							className="px-3 py-2 rounded-full bg-akgreenest text-white flex items-center gap-2 justify-between"
						>
							Create new <RiArrowDownSFill size={20} />
						</button>
					</div>
				</div>

				<div className="flex flex-col flex-grow items-center mt-4 px-12">
					{children}
				</div>
			</div>
		</div>
	);
};

export default Admin2;
